import {
  INTRANET_NOTICE_TEXT_MAX,
  type IntranetContentDetail,
  type IntranetNotice,
} from '@gb-ticket/shared-types';
import { useState } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { ApiRequestError } from '@/lib/api';
import { useSubmitIntranetNotice } from '@/products/intranet/features/intranet/use-intranet-library';

/** A required note that a published page is wrong or out of date. Separate from „Hilfreich“. */
export function NoticeForm({ content }: { content: IntranetContentDetail }) {
  const submit = useSubmitIntranetNotice(content.slug);
  const [text, setText] = useState('');
  const [sentTo, setSentTo] = useState<string[] | null>(null);

  async function send() {
    try {
      const saved: IntranetNotice = await submit.mutateAsync({ text });
      setText('');
      setSentTo(saved.recipients.map((person: { displayName: string }) => person.displayName));
      toast.success('Meldung gesendet.');
    } catch (error) {
      toast.error(error instanceof ApiRequestError ? error.message : 'Senden fehlgeschlagen.');
    }
  }

  return (
    <section
      aria-labelledby="meldung"
      className="space-y-3 rounded-xl border border-border bg-card p-4 shadow-sm sm:p-5"
    >
      <h2 id="meldung" className="font-semibold text-primary">
        Meldung
      </h2>
      <p className="text-sm text-muted-foreground">
        {content.reviewer
          ? `Zuständige Person: ${content.reviewer.displayName}`
          : 'Zuständige Person ist nicht gesetzt.'}
      </p>
      <div className="space-y-2">
        <Label htmlFor="intranet-notice">Was ist falsch oder veraltet?</Label>
        <Textarea
          id="intranet-notice"
          required
          rows={3}
          maxLength={INTRANET_NOTICE_TEXT_MAX}
          value={text}
          onChange={(event) => setText(event.target.value)}
        />
        <Button
          type="button"
          disabled={submit.isPending || text.trim().length === 0}
          onClick={() => void send()}
        >
          Meldung senden
        </Button>
      </div>
      {sentTo && sentTo.length > 0 ? (
        <p className="text-sm">Gesendet an {sentTo.join(', ')}.</p>
      ) : null}
    </section>
  );
}
